export default __webpack_public_path__ + "static/media/webapp-home-header.35ffac90.png";